module.exports = __webpack_public_path__ + "static/inkblot-logo-mlf-4fefa13a5ddcca24e6ffc25c56eb1977.png";